import React from 'react';
import { Container, Spinner } from 'reactstrap';
import { Navigate } from 'react-router-dom';

import Event from '../services/Event';
import Firebase from '../services/Firebase';
import Log from '../services/Log';
import Url from '../services/Url';
import Constants from '../Shared/Constants';
import Meta from '../Shared/Meta';
import withParams from '../Shared/withParams';
import TeamsLogo from '../assets/img/teams-logo.svg';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: true,
      token: this.props.params.token,
    };
  }

  attemptSignIn = async () => {
    if (this.state.token) {
      try {
        await Firebase.auth().signInWithCustomToken(this.state.token);
      } catch (e) {
        Event.error(Constants.SignInError);
        this.setState({
          error: Constants.SignInError,
        });
      }
    }
  }

  componentDidMount() {
    this.attemptSignIn();
  }

  render() {
    Log.message(`Loading Login`);

    // Once a user is logged in, the guard will take over

    // Error, redirect to error
    if (this.state.error) {
      const errorPath = `/error/${this.state.error}`;
      return (
        <Navigate to={errorPath} replace />
      );
    }

    // Default to spinner
    let displayContent = null;
    displayContent = <Spinner />;

    // No token, show sign up button
    if (!this.state.token) {
      displayContent =
        <div>
          <a
            href={Url.slackSignIn()}
            className="slack-signin-btn"
            style={{
              alignItems: 'center',
              color: '#000',
              backgroundColor: '#fff',
              border: '1px solid #ddd',
              borderRadius: '4px',
              display: 'inline-flex',
              fontFamily: 'Lato, sans-serif',
              fontSize: '16px',
              fontWeight: '600',
              height: '48px',
              justifyContent: 'center',
              textDecoration: 'none',
              width: '256px',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" style={{height: '20px', width: '20px', marginRight: '12px'}} viewBox="0 0 122.8 122.8">
              <path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a"></path>
              <path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0"></path>
              <path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d"></path>
              <path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e"></path>
            </svg>
            Sign in with Slack
          </a>
          <div className="auth-divider">
            <div className="auth-divider-line"></div>
            <span className="auth-divider-text">or</span>
            <div className="auth-divider-line"></div>
          </div>
          <a href={Url.teamsSignIn()} className="ms-teams-signin-btn">
            <img src={TeamsLogo} alt="Microsoft Teams logo" />
            Sign in with Microsoft Teams
          </a>
          <h5 className="jumbotron jumbotron-clear">Sign in with your workspace account<br/> to access your team's account information</h5>
        </div>;
    }

    return (
      <>
        <Meta
          pageName="Login"
          ogTitle="Login"
          ogDescription={"Login to " + Constants.AppName}
        />

        <div className="full-height section-hero section-shaped">
          <div className="shape shape-style-4 shape-default"></div>
          <Container className="body-content">
            <div className="jumbotron jumbotron-clear align-items-center justify-content-center text-center">
              {displayContent}
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default withParams(Login);
